import styled, { css } from 'styled-components/macro';
import { ControlWrapper } from '../controls.styled';
import { scaleIn } from '../controls.animation';

const sizeMap = {
  s: { size: 16, dot: 10 },
  m: { size: 24, dot: 16 },
};

export const StyledRadio = styled(ControlWrapper)`
  ${({ theme, $size }) => {
    const { size, dot } = sizeMap[$size];

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: ${size}px;
      min-height: ${size}px;
      max-width: ${size}px;
      max-height: ${size}px;
      border-radius: ${theme.radiuses.full};
      border: 1px solid ${theme.semantic.border.control};
      background-color: ${theme.semantic.control.bg};

      .radio-dot {
        display: none;
        width: ${dot}px;
        height: ${dot}px;
        border-radius: ${theme.radiuses.full};
        background-color: ${theme.semantic.control.bgChecked};
        pointer-events: none;
        transition-duration: ${theme.tokens.animation.duration.base};
        animation-name: ${scaleIn};
        animation-duration: ${theme.tokens.animation.duration.base};
        animation-timing-function: ${theme.tokens.animation.easing.elastic};
        animation-fill-mode: both;
      }

      &:has(input:checked) {
        border-color: ${theme.semantic.control.borderChecked};

        .radio-dot {
          display: block;
        }
      }

      &:not(:has(input:disabled)):hover {
        border-color: ${theme.semantic.border.controlHover};
        background-color: ${theme.semantic.control.bgHover};
      }

      &:has(input:checked):not(:has(input:disabled)):hover {
        border-color: ${theme.semantic.control.borderCheckedHover};

        .radio-dot {
          background-color: ${theme.semantic.control.bgCheckedHover};
        }
      }

      &:has(input:disabled) {
        border-color: ${theme.semantic.border.disabled};
        background-color: ${theme.semantic.control.bgDisabled};

        .radio-dot {
          background-color: ${theme.semantic.icon.onControlDisabled};
        }
      }
    `;
  }}
`;
